import React, { lazy } from 'react'
import Layout from './Layout'
import { HomePage } from '../pages/home'
import { HomePage2 } from '../pages/home/index2'
import { HomePage3 } from '../pages/home/index3'
import HeadersPage from '../pages/headers'
import FooterPage from '../pages/footers'

// Define route type
interface RouteConfig {
  path: string
  element: React.ReactElement
  meta?: {
    title: string
    description: string
  }
}

// Lazy load components for better performance
const TestimonialsPage = lazy(() =>
  import('../pages/testimonials/index').then((module) => ({
    default: module.TestimonialsPage,
  }))
)
const AboutPage = lazy(() =>
  import('../pages/about/index').then((module) => ({
    default: module.AboutPage,
  }))
)
const ServicesPage = lazy(() =>
  import('../pages/services/index').then((module) => ({
    default: module.ServicesPage,
  }))
)
const ServiceDetailPage = lazy(() =>
  import('../pages/services/details/index').then((module) => ({
    default: module.ServiceDetails,
  }))
)
const PortfolioPage = lazy(() =>
  import('../pages/portfolio/index').then((module) => ({
    default: module.PortfolioPage,
  }))
)
const PortfolioDetailPage = lazy(() =>
  import('../pages/portfolio/details/index').then((module) => ({
    default: module.PortfolioDetailsPage,
  }))
)
const BlogPage = lazy(() =>
  import('../pages/blog/index').then((module) => ({ default: module.BlogPage }))
)
const BlogDetailPage = lazy(() =>
  import('../pages/blog/details/index').then((module) => ({
    default: module.BlogDetailPage,
  }))
)
const ContactPage = lazy(() =>
  import('../pages/contact/index').then((module) => ({
    default: module.ContactPage,
  }))
)

const PricePage = lazy(() =>
  import('../pages/price/index').then((module) => ({
    default: module.PricePage,
  }))
)

const TeamPage = lazy(() =>
  import('../pages/team/index').then((module) => ({
    default: module.TeamPage,
  }))
)

const FaqPage = lazy(() =>
  import('../pages/faq/index').then((module) => ({
    default: module.FaqPage,
  }))
)

const NotFoundPage = lazy(() =>
  import('../pages/404/index').then((module) => ({
    default: module.NotFoundPage,
  }))
)

// Define routes configuration
const routes: RouteConfig[] = [
  {
    path: '/',
    element: React.createElement(Layout, null, React.createElement(HomePage)),
    meta: {
      title: 'Home - Gardenly',
      description: 'Welcome to Gardenly - Your Garden Management Solution',
    },
  },
  {
    path: '/headers',
    element: React.createElement(
      Layout,
      null,
      React.createElement(HeadersPage)
    ),
    meta: {
      title: 'headers - Gardenly',
      description: 'Welcome to Gardenly - Your Garden Management Solution',
    },
  },
  {
    path: '/footers',
    element: React.createElement(Layout, null, React.createElement(FooterPage)),
    meta: {
      title: 'Footers - Gardenly',
      description: 'Welcome to Gardenly - Your Garden Management Solution',
    },
  },
  {
    path: '/home-2',
    element: React.createElement(Layout, null, React.createElement(HomePage2)),
    meta: {
      title: 'Home - Gardenly',
      description: 'Welcome to Gardenly - Your Garden Management Solution',
    },
  },
  {
    path: '/home-3',
    element: React.createElement(Layout, null, React.createElement(HomePage3)),
    meta: {
      title: 'Home - Gardenly',
      description: 'Welcome to Gardenly - Your Garden Management Solution',
    },
  },
  {
    path: '/about',
    element: React.createElement(Layout, null, React.createElement(AboutPage)),
    meta: {
      title: 'About Us - Gardenly',
      description: 'Learn more about Gardenly and our mission',
    },
  },
  {
    path: '/services',
    element: React.createElement(
      Layout,
      null,
      React.createElement(ServicesPage)
    ),
    meta: {
      title: 'Services - Gardenly',
      description: 'Explore our comprehensive garden services',
    },
  },
  {
    path: '/services/:id',
    element: React.createElement(
      Layout,
      null,
      React.createElement(ServiceDetailPage)
    ),
    meta: {
      title: 'Service Details - Gardenly',
      description: 'Detailed information about our services',
    },
  },
  {
    path: '/portfolio',
    element: React.createElement(
      Layout,
      null,
      React.createElement(PortfolioPage)
    ),
    meta: {
      title: 'Portfolio - Gardenly',
      description: 'View our garden design portfolio and projects',
    },
  },
  {
    path: '/portfolio/:portfolioId',
    element: React.createElement(
      Layout,
      null,
      React.createElement(PortfolioDetailPage)
    ),
    meta: {
      title: 'Portfolio Details - Gardenly',
      description: 'Detailed view of our portfolio projects',
    },
  },
  {
    path: '/blog',
    element: React.createElement(Layout, null, React.createElement(BlogPage)),
    meta: {
      title: 'Blog - Gardenly',
      description: 'Read our latest articles and gardening tips',
    },
  },
  {
    path: '/blog/:blogId',
    element: React.createElement(
      Layout,
      null,
      React.createElement(BlogDetailPage)
    ),
    meta: {
      title: 'Blog Post - Gardenly',
      description: 'Read our detailed blog posts and articles',
    },
  },
  {
    path: '/contact',
    element: React.createElement(
      Layout,
      null,
      React.createElement(ContactPage)
    ),
    meta: {
      title: 'Contact Us - Gardenly',
      description: 'Get in touch with our team',
    },
  },
  {
    path: '/testimonials',
    element: React.createElement(
      Layout,
      null,
      React.createElement(TestimonialsPage)
    ),
    meta: {
      title: 'Testimonials - Gardenly',
      description: 'testimonials landscaping services',
    },
  },
  {
    path: '/price',
    element: React.createElement(
      Layout,
      null,
      React.createElement(PricePage)
    ),
    meta: {
      title: 'Testimonials - Gardenly',
      description: 'testimonials landscaping services',
    },
  },
  {
    path: '/team',
    element: React.createElement(
      Layout,
      null,
      React.createElement(TeamPage)
    ),
    meta: {
      title: 'Testimonials - Gardenly',
      description: 'testimonials landscaping services',
    },
  },
  {
    path: '/faq',
    element: React.createElement(
      Layout,
      null,
      React.createElement(FaqPage)
    ),
    meta: {
      title: 'Testimonials - Gardenly',
      description: 'testimonials landscaping services',
    },
  },
  {
    path: '*',
    element: React.createElement(
      Layout,
      null,
      React.createElement(NotFoundPage)
    ),
    meta: {
      title: '404 - Page Not Found - Gardenly',
      description: 'The page you are looking for does not exist',
    },
  },
]

export default routes
